import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/text-hol.png'
import _imports_1 from '../assets/wxts.png'
import _imports_2 from '../assets/kfIcon.png'


const _withScopeId = n => (_pushScopeId("data-v-40e3fe20"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = {
  style: {"width":"100%"},
  alt: ""
}
const _hoisted_4 = { class: "sellOrPrice" }
const _hoisted_5 = { class: "price" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"0.24rem"} }, "￥", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sell" }, "月售199+件", -1))
const _hoisted_8 = { class: "name" }
const _hoisted_9 = { class: "tag" }
const _hoisted_10 = { style: {"display":"flex","flex":"1","flex-wrap":"wrap"} }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "wly" }, "包邮", -1))
const _hoisted_12 = { class: "type" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "流量类型", -1))
const _hoisted_14 = { class: "typeFlex" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "type" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "流量档位", -1))
const _hoisted_18 = { class: "typeFlex" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "type" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "选择天数", -1))
const _hoisted_22 = { class: "typeFlex" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "tips" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "温馨提示", -1))
const _hoisted_26 = { class: "tipsContent" }
const _hoisted_27 = { class: "type" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "商品描述", -1))
const _hoisted_29 = {
  key: 0,
  src: _imports_0,
  class: "goodImg",
  alt: ""
}
const _hoisted_30 = {
  class: "goodImg",
  alt: ""
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "goodImg",
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_32 = { class: "footer" }
const _hoisted_33 = { class: "footContent" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "kfIcon",
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" 客服 ")
const _hoisted_36 = [
  _hoisted_34,
  _hoisted_35
]
const _hoisted_37 = { class: "flex" }
const _hoisted_38 = /*#__PURE__*/_createTextVNode(" 合计: ")
const _hoisted_39 = { class: "price" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"0.24rem"} }, "￥", -1))
const _hoisted_41 = /*#__PURE__*/_createTextVNode("立即购买")

import { NavBar, Button, Toast } from "vant";
import router from "@/router";
import { computed, ref, inject } from "vue";
import { useRoute } from "vue-router";
import { request } from "@/provide/fetch";


export default /*#__PURE__*/_defineComponent({
  name: 'hotGoodsDetails',
  setup(__props) {

const route = useRoute();
const goodeId = route.params.id;
const goodvalue = ref({
  mainPicUrl: "",
  productPrice: "",
  productName: "",
  productSellPoints: [],
  productComment: "",
  lastUseTime: "",
  detailPicUrl: "",
  childProductSelect: {},
  childProductCode: "",
});
const activeFlowType = ref();
const activeFlowGear = ref();
const activeFate = ref();
const isHoliday = ref(new Date() < new Date("2025-02-06"));

const handleData = () => {
  request({
    url: `/product/get-child-product-select?product_id=${goodeId}`,
  })
    .then((res) => {
      goodvalue.value = res.data;
      activeFlowType.value = Object.keys(res.data.childProductSelect)[0];
      activeFlowGear.value = Object.keys(
        res.data.childProductSelect[activeFlowType.value]
      )[0];
      activeFate.value = Object.values(
        res.data.childProductSelect[activeFlowType.value][activeFlowGear.value]
      )[0];
      handleDetails();
    })
    .catch(() => {
      Toast("网络错误，请稍后重试");
    });
};
handleData();
const flowType = computed(() => {
  return Object.keys(goodvalue.value.childProductSelect || {});
});
const flowGear = computed(() => {
  return Object.keys(goodvalue.value.childProductSelect?.[activeFlowType.value] || {});
});
const fateList = computed(() => {
  return Object.values(
    goodvalue.value.childProductSelect?.[activeFlowType.value]?.[activeFlowGear.value] || {}
  );
});
const handleFlowType = (item: string | number) => {
  activeFlowType.value = item;
  activeFlowGear.value = flowGear.value[0];
  activeFate.value = fateList.value[0];
  handleDetails();
};
const handleFlowGear = (item: string | number) => {
  activeFlowGear.value = item;
  activeFate.value = fateList.value[0];
  handleDetails();
};
const handleFate = (item: string | number) => {
  activeFate.value = item;
  handleDetails();
};
const handleDetails = () => {
  request({
    url: `/product/get-child-product`,
    method: "POST",
    data: {
      flowLevel: activeFlowGear.value,
      selectDays: activeFate.value,
      flowType: activeFlowType.value,
      productId: Number(goodeId),
    },
  })
    .then((res) => {
      goodvalue.value.productPrice = res.data.productPrice;
      goodvalue.value.productComment = res.data.productComment;
      goodvalue.value.lastUseTime = res.data.lastUseTime;
      goodvalue.value.childProductCode = res.data.childProductCode;
      goodvalue.value.mainPicUrl = res.data.mainPicUrl;
      goodvalue.value.detailPicUrl = res.data.detailPicUrl;
    })
    .catch(() => {
      Toast("网络错误，请稍后重试");
    });
};
const handleSubmit = () => {
  router.push({
    path: "/submitOrder",
    query: {
      id: goodeId,
      activeFlowType: activeFlowType.value,
      activeFlowGear: activeFlowGear.value,
      activeFate: activeFate.value,
      productCode: goodvalue.value.childProductCode,
    },
  });
};
const handleShowCustomerService = inject(
  "handleShowCustomerService"
) as () => void;
const handleKf = () => {
  handleShowCustomerService();
};

return (_ctx: any,_cache: any) => {
  const _component_lazy_component = _resolveComponent("lazy-component")!
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(NavBar), {
      title: "商品详情",
      "left-arrow": "",
      onClickLeft: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).go(-1)))
    }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_lazy_component, null, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("img", _hoisted_3, null, 512), [
            [_directive_lazy, goodvalue.value.mainPicUrl]
          ])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createTextVNode(_toDisplayString(goodvalue.value.productPrice), 1)
        ]),
        _hoisted_7
      ]),
      _createElementVNode("div", _hoisted_8, _toDisplayString(goodvalue.value.productName), 1),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(goodvalue.value.productSellPoints, (item) => {
            return (_openBlock(), _createElementBlock("span", {
              key: item,
              class: "tagItem"
            }, _toDisplayString(item), 1))
          }), 128))
        ]),
        _hoisted_11
      ]),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("div", _hoisted_14, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(flowType), (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["typeItem", { active: activeFlowType.value === item }]),
              key: item,
              onClick: ($event: any) => (handleFlowType(item))
            }, _toDisplayString(item), 11, _hoisted_15))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _hoisted_17,
        _createElementVNode("div", _hoisted_18, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(flowGear), (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["typeItem", { active: activeFlowGear.value === item }]),
              key: item,
              onClick: ($event: any) => (handleFlowGear(item))
            }, _toDisplayString(item), 11, _hoisted_19))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _hoisted_21,
        _createElementVNode("div", _hoisted_22, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(fateList), (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["typeItem", { active: activeFate.value === item }]),
              key: index,
              onClick: ($event: any) => (handleFate(item))
            }, _toDisplayString(item), 11, _hoisted_23))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_24, [
        _hoisted_25,
        _createElementVNode("div", _hoisted_26, _toDisplayString(goodvalue.value.productComment) + "，最晚使用时间到" + _toDisplayString(goodvalue.value.lastUseTime), 1)
      ]),
      _createElementVNode("div", _hoisted_27, [
        _hoisted_28,
        (isHoliday.value)
          ? (_openBlock(), _createElementBlock("img", _hoisted_29))
          : _createCommentVNode("", true),
        _createVNode(_component_lazy_component, null, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("img", _hoisted_30, null, 512), [
              [_directive_lazy, goodvalue.value.detailPicUrl]
            ]),
            _hoisted_31
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_32, [
      _createElementVNode("div", _hoisted_33, [
        _createElementVNode("div", {
          class: "kf",
          onClick: handleKf
        }, _hoisted_36),
        _createElementVNode("div", _hoisted_37, [
          _hoisted_38,
          _createElementVNode("div", _hoisted_39, [
            _hoisted_40,
            _createTextVNode(_toDisplayString(goodvalue.value.productPrice), 1)
          ])
        ]),
        _createVNode(_unref(Button), {
          class: "submitBtn",
          onClick: handleSubmit
        }, {
          default: _withCtx(() => [
            _hoisted_41
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})